<template>
	<div class="material toggle" v-on:click="toggle()">
		<div class="frame" v-bind:class="{
			on: checked,
		}">
			<div class="pin"></div>
		</div>
		<div v-if="label" class="text">
			{{ label }}
			<div v-if="note" class="note">{{ note }}</div>
			<div v-if="tooltip" class="tooltip">{{ tooltip }}</div>
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'note',
    'tooltip'
  ],
  computed: {
    checked: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    toggle () {
      this.checked = !this.checked
    }
  }
}
</script>
